module.exports = __webpack_public_path__ + "585ec4bc3516462aec38a8168c8b7540.svg";